import { render } from "./resources-show.vue?vue&type=template&id=1581a4ef&scoped=true"
import script from "./resources-show.vue?vue&type=script&lang=js"
export * from "./resources-show.vue?vue&type=script&lang=js"

import "./resources-show.vue?vue&type=style&index=0&id=1581a4ef&lang=scss&scoped=true"
import "./resources-show.vue?vue&type=style&index=1&id=1581a4ef&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1581a4ef"]])

export default __exports__